<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div
          v-for="(item, index) in input.options"
          v-bind:key="item.value"
          :style="
            input.class == 'block'
              ? 'display:block'
              : 'display:inline-block;margin-right:1.5rem'
          "
        >
          <div
            class="radio custom-control custom-radio"
            :style="
              input.disabled || input.readonly ? 'pointer-events: none;' : ''
            "
          >
            <input
              class="custom-control-input"
              type="radio"
              :checked="
                thisValue == item.value ||
                  String(thisValue) == String(item.value)
              "
              :name="input.name"
              :id="input.name + index"
              autocomplete="off"
              :value="item.value"
              :disabled="input.disabled"
              :readonly="input.readonly"
              @change="handleChange"
            />
            <!-- {{thisValue}} O {{item.value}} -->
            <!-- {{thisValue == item.value}} -->
            <label class="custom-control-label" :for="input.name + index">{{
              item.label
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let id = Math.random(1024);
export default {
  name: "InputRadioOld",
  components: {},
  props: {
    input: Object,
    value: [String, Boolean, Number],
  },
  data: function() {
    return {
      id: id,
      thisValue: this.value,
    };
  },
  methods: {
    handleChange(e) {
      ////console.log(e);
      this.thisValue = e.target.value;
      ////console.log(this.thisValue + " haha");
      this.$emit("handleChange", e);
    },
  },
};
</script>
